export const sidebarIcons = {
  search: "search",
  match: "record_voice_over",
  settings: "settings"
};

export const sidebarTexts = {
  search: "Discover",
  match: "Matches",
  settings: "Profile"
};
